const fakeNewsService = {
    getNews: async function () {
        return Promise.resolve([
            {
                title: "Sommerfest 2026",
                image: "files/Flyer Sommerfest.png",
                content: "Wann: Samstag 13.06.2026 ab 14:00\n\r" +
                    "Wo: Kleingärtnerverein Gartenfreunde Opladen (Kettnersbusch)\n\r",
                files: [{
                    title: "Sommerfest 2026",
                    src: "files/Flyer Sommerfest.pdf"
                }]
            },
            {
                title: "Kellergaudi 2026",
                image: "files/Flyer Kellergaudi.png",
                content: "Wann: Freitag 02.10.2026 ab 19:00\n\r" +
                    "Wo: Funkenkeller, Birkenbergstraße 33 in Opladen\n\r",
                files: [{
                    title: "Kellergaudi 2026",
                    src: "files/Flyer Kellergaudi.pdf"
                }]
            },
            {
                title: "Stonn op un Danz 2026",
                image: "files/Flyer SOUD.png",
                content: "Wann: Freitag 06.11.2026 ab 18:30\n\r" +
                    "Wo: Scala Club Leverkusen",
                files: [{
                    title: "Stonn op un Danz 2026",
                    src: "files/Flyer SOUD.pdf"
                }]
            },
            {
                title: "Kindersitzung 2027",
                image: "files/Plakat KS 2027 A4.png",
                content: "Wann: Sonntag 17.01.2027 ab 13:00\n\r" +
                    "Wo: Scala Club Opladen, Uhlandstr. 9, 51379 Leverkusen-Opladen\n\r" +
                    "Kinder 9,00 €, Erwachsene 12,00 €\n\r",
                files: [{
                    title: "Kindersitzung 2027",
                    src: "files/Plakat KS 2027 A4.pdf"
                }]
            },
            {
                title: "Feldmesse 2027",
                image: "files/Flyer Feldmesse.png",
                content: "Wann: Sonntag 24.01.2027 ab 9:30\n\r" +
                    "Wo: St. Elisabeth Kirche, Kölner Straße 139, 51379 Leverkusen-Opladen\n\r",
                files: [{
                    title: "Feldmesse 2027",
                    src: "files/Flyer Feldmesse.pdf"
                }]
            },
            {
                title: "Herrensitzung 2027",
                image: "files/Flyer Herrensitzung.png",
                content: "Wann: Sonntag 31.01.2027 ab 13:30\n\r" +
                    "Wo: Festzelt am Marktplatz Opladen\n\r",
                files: [{
                    title: "Herrensitzung 2027",
                    src: "files/Flyer Herrensitzung.pdf"
                }]
            },
            {
                title: "Kellerveranstaltungen 2026 / 2027",
                image: "files/Flyer Kellerveranstaltungen.png",
                // content: "Wann: Sonntag 08.02.2026 ab 13:30\n\r" +
                //     "Wo: Festzelt am Marktplatz Opladen\n\r",
                files: [{
                    title: "Kellerveranstaltungen 2026 / 2027",
                    src: "files/Flyer Kellerveranstaltungen.pdf"
                }]
            }
        ]);
    }
}

export default fakeNewsService;